__turbopack_context__.v({
  "card": "_16uPrG_card",
  "header": "_16uPrG_header",
  "headerTop": "_16uPrG_headerTop",
  "legs": "_16uPrG_legs",
  "subtitle": "_16uPrG_subtitle",
});
